/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Payroll_SuccessInputs */

const es_tools_legajox_payroll_success = /** @type {(inputs: Tools_Legajox_Payroll_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibos de sueldo de Legajox consultados`)
};

const en_tools_legajox_payroll_success = /** @type {(inputs: Tools_Legajox_Payroll_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox payroll queried`)
};

/**
* | output |
* | --- |
* | "Legajox payroll queried" |
*
* @param {Tools_Legajox_Payroll_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_payroll_success = /** @type {((inputs?: Tools_Legajox_Payroll_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Payroll_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_payroll_success(inputs)
	return en_tools_legajox_payroll_success(inputs)
});
export { tools_legajox_payroll_success as "tools.legajox.payroll_success" }